import { makeStyles } from "tss-react/mui";
import { MiBuildPageHeader, MiButton } from "@miplatform/components";
import { BUTTON_VARIANTS } from "@miplatform/constants";
import { useContactGroups } from "@mibuildweb/utils";
import { Box } from "@mui/system";
import { ContactsListSection } from "../Contacts/ContactsListSection";

/**
 *
 * @param {object} props
 * @param {object} props.data - filtered list of contacts to display in the contacts tab view
 * @param {string} props.label - The label to display at the top of the contacts tab view
 * @param {object[]} props.contacts - Full list of contacts
 * @param {function} props.handleSearch - The function to call when the search input changes
 * @param {function} props.openDrawer - The function to call to open the add contact drawer
 * @param {string} props.search - The current search value
 * @param {function} props.renderContactCard - The function to render a contact card
 * @returns JSX.Element
 */
export const ContactsTabView = ({
  data,
  label,
  contacts,
  handleSearch,
  openDrawer,
  search,
  renderContactCard,
}) => {
  const { classes } = useStyles();
  const { groupedContacts } = useContactGroups(contacts, data);
  return (
    <>
      <MiBuildPageHeader
        title={label || "Contacts"}
        hasDivider={false}
        titleFontSize={18}
        searchPlaceholder="Find Contact"
        search={search}
        onHandleSearch={(e) => handleSearch(e.target.value)}
        actionComponent={
          <MiButton
            title="Add Contact"
            variant={BUTTON_VARIANTS.OUTLINED}
            onClick={openDrawer}
            data-testid="add-contact-btn"
          />
        }
      />

      <Box className={classes.content}>
        {groupedContacts.map(([accountName, contacts]) => (
          <ContactsListSection
            key={accountName}
            header={accountName}
            items={contacts}
            renderCard={renderContactCard}
          />
        ))}
      </Box>
    </>
  );
};

const useStyles = makeStyles()((theme) => ({
  content: {
    display: "grid",
    gridTemplateColumns: `repeat(auto-fit, minmax(max(330px, 48%), 1fr))`,
    gap: theme.spacing(4),
    overflow: "auto",
  },
}));
